// bloqueio-motivo-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Bloquear cliente": "Bloquear cliente",
    "Fica salvo nas Observações do cadastro.": "Queda guardado en las Observaciones del registro.",
    "Motivo do bloqueio": "Motivo del bloqueo",
};

export default catalogo;
